import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from './routes';
import LoadingScreen from '@/components/ui/LoadingScreen';

/**
 * Routes publiques uniquement.
 * Si déjà connecté + email vérifié → redirige vers /home.
 */
export default function PublicRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) return <LoadingScreen />;

  if (isAuthenticated && user?.emailVerified) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
}
